const cartItemDefaultState = {
    id: 0,
    quantity: 1,
    crust_id: 0,
    sauce_id: 0,
    item_id: 0,
    size_id: 0,
    price_id: 0,
    max_toppings: 0,
    price_name: '',
    price_price: 0,
    pizzatype: '',
    instructions: '',
    toppings: [],
    choices: [],
    items: [],
    addons: [],
    modifiers: [],
    error: false,
};

export default (state = cartItemDefaultState, action) => {

    switch(action.type) {

        case 'CART_ITEM_QUANTITY_ADD':
            return {
                ...state,
                quantity: state.quantity+1
            }

        case 'CART_ITEM_QUANTITY_SUBTRACT':
            return {
                ...state,
                quantity: (state.quantity - 1 < 1) ? 1 : state.quantity - 1
            }

        case 'CART_INSTRUCTIONS_UPDATE':
            return {
                ...state,
                instructions: action.instructions
            }

        case 'CART_ITEM_ID_UPDATE':
            return {
                ...state,
                item_id: action.id,
                id: action.id
            }

        case 'CART_ITEM_PIZZATYPE_UPDATE':
            return {
                ...state,
                pizzatype: action.pizzatype
            }

        case 'CART_ITEM_PRICE_UPDATE':
            return {
                ...state,
                price_id: action.price_id,
                size_id: action.price_id,
                price_name: action.price_name,
                price_price: action.price_price
            }

        case 'CART_ITEM_LOAD_TOPPINGS':
            return {
                ...state,
                toppings: action.toppings
            }

        case 'CART_ITEM_LOAD_SPECIAL_ITEMS':
            return {
                ...state,
                items: action.items
            }

        case 'CART_ITEM_CRUST_UPDATE':
            return {
                ...state,
                crust_id: action.crust_id
            }

        case 'CART_ITEM_SAUCE_UPDATE':
            return {
                ...state,
                sauce_id: action.sauce_id
            }

        case 'CART_ITEM_MAX_TOPPINGS_UPDATE':
            return {
                ...state,
                max_toppings: action.max_toppings
            }

        case 'CART_ITEM_LOAD_CHOICES':
            return {
                ...state,
                choices: action.choices
            }

        case 'CART_ITEM_UPDATE_SINGLE_CHOICE':
            return {
                ...state,
                choices: state.choices.map((theChoice) => {
                    if (theChoice.id == action.choice_id) {

                        // we have a match, update the info
                        theChoice.item_name = action.item.name;
                        theChoice.item_price = action.item.price;
                        theChoice.item_id = action.item.id;
                    }
                    
                    return theChoice;
                })
            }

        case 'CART_ITEM_UPDATE_MULTIPLE_CHOICES':
            return {
                ...state,
                choices: state.choices.map((theChoice) => {
                    if (theChoice.id == action.choice_id) {
                        
                        // we have a match, update the info
                        theChoice.items = action.items;
                        theChoice.item_name = action.item_name;
                    }
                    
                    return theChoice;
                })
            }

        case 'CART_ITEM_LOAD_MODIFIERS':
            return {
                ...state,
                modifiers: action.modifiers
            };

        case 'CART_ITEM_UPDATE_SINGLE_MODIFIER':
            return {
                ...state,
                modifiers: state.modifiers.map((foodItemModifier) => {
                    if (foodItemModifier.foodItemModifierID == action.foodItemModifierID) {
                        foodItemModifier.items = [{
                            id: action.item.id,
                            name: action.item.name,
                            price: action.item.prices[0].price
                        }];
                    }                    
                    return foodItemModifier;
                })
            };

        case 'CART_ITEM_ADD_MODIFIER_ITEM':
            return {
                ...state,
                modifiers: state.modifiers.map((foodItemModifier) => {
                    if (foodItemModifier.foodItemModifierID == action.foodItemModifierID) {
                        foodItemModifier.items = foodItemModifier.items.concat(action.item);
                    }
                    return foodItemModifier;
                })
            };
    
        case 'CART_ITEM_REMOVE_MODIFIER_ITEM':
            return {
                ...state,
                modifiers: state.modifiers.map((foodItemModifier) => {
                    if (foodItemModifier.foodItemModifierID == action.foodItemModifierID) {
                        foodItemModifier.items = foodItemModifier.items.filter((item) => item.id != action.item.id)
                    }
                    return foodItemModifier;
                })
            };

        case 'CART_ITEM_ADDON_ADD':
            return {
                ...state,
                addons: state.addons.concat(action.addon)
            }

        case 'CART_ITEM_ADDON_REMOVE':
            return {
                ...state,
                addons: state.addons.filter((addon) => addon != action.addon)
            }

        case 'CART_ITEM_RESET':
            return cartItemDefaultState;

        default:
            return state;
    }
};